import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarSeparator,
  MenubarShortcut,
  MenubarTrigger,
} from '@/components/ui/menubar';
import { useAuth } from '@/features/auth/auth.hooks';
import { useProfile } from '@/hooks/use-profile';
import { AvatarImage } from '@radix-ui/react-avatar';
import { LayoutDashboard, LogOut, UserRound } from 'lucide-react';
import { useNavigate } from 'react-router';
import useConsoleMenu from '../hooks/use-console-menu';

function ProfileMenu() {
  const { logout } = useAuth();
  const { data: profile } = useProfile();
  const navigate = useNavigate();

  const goToProfile = () => {
    if (profile?.id) {
      navigate(`/user-access/employee-management/form/${profile.id}`);
    }
  };

  return (
    <Menubar className="border-0 bg-transparent shadow-none">
      <MenubarMenu>
        <MenubarTrigger asChild className="rounded bg-transparent">
          <Button size="sm" variant="ghost">
            <Avatar>
              <AvatarImage src={profile?.profilePicture?.url ?? undefined} />
              <AvatarFallback>{profile?.name?.at(0)}</AvatarFallback>
            </Avatar>
            {profile?.name ?? ''}
          </Button>
        </MenubarTrigger>

        <MenubarContent align="end">
          <MenubarItem onClick={() => navigate('/planner')}>
            Exit to CMS
            <MenubarShortcut>
              <LayoutDashboard />
            </MenubarShortcut>
          </MenubarItem>
          <MenubarSeparator />
          <MenubarItem onClick={goToProfile}>
            Profile
            <MenubarShortcut>
              <UserRound />
            </MenubarShortcut>
          </MenubarItem>
          <MenubarSeparator />
          <MenubarItem onClick={logout}>
            Logout
            <MenubarShortcut>
              <LogOut />
            </MenubarShortcut>
          </MenubarItem>
        </MenubarContent>
      </MenubarMenu>
    </Menubar>
  );
}

function ConsoleHeader() {
  const { currentRoute } = useConsoleMenu();
  const { data: profile } = useProfile();

  return (
    <>
      <header className="hidden w-full items-center justify-between rounded-2xl p-6 md:flex">
        <h4 className="text-text-primary text-2xl font-bold">
          {currentRoute?.label ?? 'Superadmin Console'}
        </h4>

        <div className="flex h-full items-center space-x-4">
          <ProfileMenu />
        </div>
      </header>

      <header className="relative flex items-center gap-6 bg-neutral-100 px-6 py-[18px] md:hidden">
        <div className="flex w-full items-center justify-between">
          <h5 className="text-text-primary pl-6 text-xl font-bold">
            👋 Hi {profile?.name}
          </h5>
          <ProfileMenu />
        </div>
      </header>
    </>
  );
}

export { ConsoleHeader };
